{
  "familyId": "SPR-KLANK-AU-OU",
  "questions": [
    {
      "id": "SPR-KLANK-AU-OU-001",
      "familyId": "SPR-KLANK-AU-OU",
      "module": "SpellingRegel",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_au_ou",
      "questionType": "multiple_choice",
      "question": "Welk woord schrijf je met 'au'?",
      "options": ["blauw", "koud", "goud", "hout"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Au of ou?", "content": "De klanken 'au' en 'ou' klinken hetzelfde, maar je schrijft ze anders. Dit zijn weetwoorden — je moet ze uit je hoofd leren.\n\nMet au: blauw, gauw, nauw, rauw, flauw\nMet ou: oud, koud, goud, hout, zout", "icon": "lightbulb" } }
      ],
      "conceptId": "au_ou_blauw",
      "variantIndex": 1,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "'Blauw' schrijf je met 'au'. Dit is een weetwoord — je moet het uit je hoofd leren. De andere drie woorden (koud, goud, hout) schrijf je met 'ou'. Onthoud de au-woorden: blauw, gauw, nauw, rauw, flauw.",
        "solutionSteps": ["Blauw → au (weetwoord)", "Koud, goud, hout → ou", "Onthoud: blauw, gauw, nauw, rauw, flauw zijn au-woorden"],
        "distractorExplanations": {
          "0": "Goed! 'Blauw' schrijf je met 'au'.",
          "1": "'Koud' schrijf je met 'ou', niet 'au'. Onthoud: koud, oud, goud, hout, zout → allemaal ou.",
          "2": "'Goud' schrijf je met 'ou', niet 'au'. Onthoud: goud, koud, oud → allemaal ou.",
          "3": "'Hout' schrijf je met 'ou', niet 'au'. Onthoud: hout, zout, bout → allemaal ou."
        }
      }
    },
    {
      "id": "SPR-KLANK-AU-OU-002",
      "familyId": "SPR-KLANK-AU-OU",
      "module": "SpellingRegel",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_au_ou",
      "questionType": "multiple_choice",
      "question": "Welk woord schrijf je met 'ou'?",
      "options": ["gauw", "blauw", "koud", "nauw"],
      "correctAnswer": 2,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Ou-woorden", "content": "Veelvoorkomende ou-woorden: oud, koud, goud, hout, zout, bout, mouw, vrouw, trouw.\n\nTip: de meeste woorden met deze klank schrijf je met 'ou'. Woorden met 'au' zijn de uitzonderingen.", "icon": "lightbulb" } }
      ],
      "conceptId": "au_ou_koud",
      "variantIndex": 2,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "'Koud' schrijf je met 'ou'. De andere drie (gauw, blauw, nauw) schrijf je met 'au'. Tip: de meeste woorden schrijf je met 'ou' — de au-woorden zijn de uitzonderingen.",
        "solutionSteps": ["Koud → ou (oud, koud, goud, hout, zout)", "Gauw, blauw, nauw → au (uitzonderingen)"],
        "distractorExplanations": {
          "0": "'Gauw' schrijf je met 'au', niet 'ou'.",
          "1": "'Blauw' schrijf je met 'au', niet 'ou'.",
          "2": "Goed! 'Koud' schrijf je met 'ou'.",
          "3": "'Nauw' schrijf je met 'au', niet 'ou'."
        }
      }
    },
    {
      "id": "SPR-KLANK-AU-OU-003",
      "familyId": "SPR-KLANK-AU-OU",
      "module": "SpellingRegel",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_au_ou",
      "questionType": "multiple_choice",
      "question": "Welke zin is correct gespeld?",
      "options": [
        "De aude vrouw loopt gauw naar huis.",
        "De oude vrouw loopt gauw naar huis.",
        "De oude vrouw loopt gouw naar huis.",
        "De aude vrouw loopt gouw naar huis."
      ],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Au en ou in één zin", "content": "'Oude' en 'vrouw' schrijf je met ou.\n'Gauw' schrijf je met au.\n\nOnthoud: de meeste woorden → ou. Uitzonderingen → au.", "icon": "lightbulb" } }
      ],
      "conceptId": "au_ou_gemengd_zin",
      "variantIndex": 3,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "'Oude' → ou, 'vrouw' → ou, 'gauw' → au. Dus: 'De oude vrouw loopt gauw naar huis.' In deze zin zitten zowel ou-woorden als een au-woord. Let goed op welke klank bij welk woord hoort.",
        "solutionSteps": ["Oude → ou (oud, koud, goud)", "Vrouw → ou", "Gauw → au (uitzondering)", "Controleer: oude (ou) ✓, vrouw (ou) ✓, gauw (au) ✓"],
        "distractorExplanations": {
          "0": "'Aude' is fout. Het is 'oude' met ou. Maak het meervoud: oud → oude.",
          "1": "Goed! Oude (ou), vrouw (ou), gauw (au) — alles correct.",
          "2": "'Gouw' is fout. Het is 'gauw' met au. Gauw is een au-uitzondering.",
          "3": "Beide fouten: 'aude' moet 'oude' zijn (ou), 'gouw' moet 'gauw' zijn (au)."
        }
      }
    },
    {
      "id": "SPR-KLANK-AU-OU-004",
      "familyId": "SPR-KLANK-AU-OU",
      "module": "SpellingRegel",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_au_ou",
      "questionType": "multiple_choice",
      "question": "Welke reeks woorden schrijf je ALLEMAAL met 'au'?",
      "options": [
        "koud, oud, goud, hout",
        "blauw, koud, gauw, oud",
        "rauw, zout, flauw, bout",
        "blauw, gauw, rauw, flauw"
      ],
      "correctAnswer": 3,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Au-woorden onthouden", "content": "De belangrijkste au-woorden:\nblauw, gauw, nauw, rauw, flauw, pauze, saus, applaus\n\nAlle andere woorden met deze klank → ou.", "icon": "lightbulb" } }
      ],
      "conceptId": "au_ou_reeks_herkennen",
      "variantIndex": 4,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Blauw, gauw, rauw, flauw — allemaal au-woorden. De andere reeksen bevatten ou-woorden (koud, oud, goud, hout, zout, bout). Tip: de au-woorden zijn de uitzonderingen. Leer ze uit je hoofd!",
        "solutionSteps": ["Blauw → au ✓", "Gauw → au ✓", "Rauw → au ✓", "Flauw → au ✓", "Controleer de andere reeksen: koud, oud, goud, hout, zout, bout → allemaal ou"],
        "distractorExplanations": {
          "0": "Koud, oud, goud, hout zijn ou-woorden, niet au.",
          "1": "Gemengd: blauw en gauw zijn au, maar koud en oud zijn ou.",
          "2": "Gemengd: rauw en flauw zijn au, maar zout en bout zijn ou.",
          "3": "Goed! Allemaal au-woorden."
        }
      }
    },
    {
      "id": "SPR-KLANK-AU-OU-005",
      "familyId": "SPR-KLANK-AU-OU",
      "module": "SpellingRegel",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_au_ou",
      "questionType": "fill_in",
      "question": "Schrijf het woord goed: het is vandaag erg ... buiten. (Het woord rijmt op 'oud'.)",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["koud"],
        "caseSensitive": false,
        "placeholder": "typ het woord"
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Koud → ou", "content": "'Koud' schrijf je met 'ou'. Onthoud: koud, oud, goud, hout, zout → allemaal ou.", "icon": "lightbulb" } }
      ],
      "conceptId": "au_ou_fill_koud",
      "variantIndex": 5,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "'Koud' schrijf je met 'ou'. Dit is een weetwoord. Het rijmt op 'oud' — en 'oud' schrijf je ook met 'ou'. Andere ou-woorden: goud, hout, zout.",
        "solutionSteps": ["Het woord rijmt op 'oud' → koud", "Koud → ou (weetwoord)", "Onthoud: koud, oud, goud, hout, zout → ou"]
      }
    },
    {
      "id": "SPR-KLANK-AU-OU-006",
      "familyId": "SPR-KLANK-AU-OU",
      "module": "SpellingRegel",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_au_ou",
      "questionType": "categorize",
      "question": "Sorteer deze woorden: schrijf je ze met 'au' of met 'ou'?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "categories": ["Met au", "Met ou"],
        "items": [
          { "text": "blauw", "correctCategory": 0 },
          { "text": "koud", "correctCategory": 1 },
          { "text": "gauw", "correctCategory": 0 },
          { "text": "goud", "correctCategory": 1 },
          { "text": "rauw", "correctCategory": 0 },
          { "text": "hout", "correctCategory": 1 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Au of ou?", "content": "Met au: blauw, gauw, rauw, nauw, flauw (uitzonderingen — leer ze uit je hoofd).\nMet ou: koud, goud, hout, zout, oud (de meeste woorden).\n\nTip: de meeste woorden schrijf je met 'ou'. De au-woorden zijn de uitzonderingen.", "icon": "lightbulb" } }
      ],
      "conceptId": "au_ou_categorize",
      "variantIndex": 6,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Met au: blauw, gauw, rauw — dit zijn uitzonderingen die je uit je hoofd moet leren. Met ou: koud, goud, hout — de meeste woorden met deze klank schrijf je met 'ou'.",
        "solutionSteps": [
          "Au-woorden (uitzonderingen): blauw, gauw, rauw",
          "Ou-woorden (standaard): koud, goud, hout",
          "Tip: de meeste woorden → ou. Uitzonderingen → au."
        ]
      },
      "pedagogy": {
        "dok": 1
      }
    }
  ]
}